function isInStandaloneMode(window) {
  const userAgent = window.navigator.userAgent
  const iosApp = /iOSApp/.test(userAgent)
  return iosApp || (window.matchMedia('(display-mode: standalone)').matches) || (window.navigator.standalone) || document.referrer.includes('android-app://')
}

export {
  isInStandaloneMode
}
